/** Domain API del módulo Compras — tipos, funciones puras, constantes.
 * Cero dependencias en infra/app/ui. Importar desde acá para evitar require cycles. */

// purchaseTypes
export type {
  PurchaseOrderStatus,
  PurchaseOrderOrigin,
  PurchaseReceptionStatus,
  PurchaseReturnStatus,
  PurchaseOrderRow,
  PurchaseOrderItemRow,
  PurchaseReceptionRow,
  PurchaseReceptionItemRow,
  PurchaseReturnRow,
  PurchaseReturnItemRow,
  PurchaseOrderWithItems,
  PurchaseReceptionWithItems,
  PurchaseListQuery,
  PurchasesSummary,
} from './domain/purchaseTypes';
export { PURCHASES_LIST_PAGE_SIZE } from './domain/purchaseTypes';

// purchaseQueues
export {
  PURCHASE_QUEUE_LABELS,
  PURCHASE_QUEUE_IDS,
  countPurchaseQueues,
  formatPurchaseQueueChipLabel,
  isOverdueExpense,
  isToPayExpense,
  isToReceiveStatus,
  purchaseOrderIdsForQueue,
} from './domain/purchaseQueues';
export type {
  PurchaseQueueCounts,
  PurchaseQueueExpense,
  PurchaseQueueFilter,
  PurchaseQueueId,
} from './domain/purchaseQueues';

// purchaseLabels
export {
  PURCHASE_ORDER_STATUS_LABELS,
  PURCHASE_RECEPTION_STATUS_LABELS,
  PURCHASE_RETURN_STATUS_LABELS,
  purchaseOrderStatusLabel,
  purchaseReceptionStatusLabel,
  purchaseReturnStatusLabel,
  purchaseCreditBannerText,
} from './domain/purchaseLabels';

// purchaseValidation
export {
  validatePurchaseOrderForm,
  validateReceptionForm,
  validateVoidReason,
  validateCloseReason,
  canSendPurchaseOrder,
  canReceivePurchaseOrder,
  canVoidPurchaseOrder,
  canClosePurchaseOrder,
  formatPurchaseOrderNumber,
} from './domain/purchaseValidation';

// purchaseIva
export {
  splitPurchaseUnitCost,
  stockUnitCostForRegime,
} from './domain/purchaseIva';
export type { PurchaseTaxRegime, PurchaseLineCostSplit } from './domain/purchaseIva';

// purchaseOrderShareText
export {
  buildPurchaseOrderShareText,
  canSharePurchaseOrder,
} from './domain/purchaseOrderShareText';

// purchaseSupplierFicha
export {
  dueDateFromPaymentTerms,
  expectedDeliveryFromLeadTime,
  hasDuplicateSupplierInvoiceRef,
  lastUnitCostPrefill,
  minOrderBelowWarning,
  parsePaymentTermsDays,
} from './domain/purchaseSupplierFicha';

// stockTransferTypes
export type {
  StockTransferRow,
  StockTransferItemRow,
  StockTransferWithItems,
  CreateStockTransferInput,
  CreateStockTransferResult,
  VoidStockTransferInput,
  CreateStockTransferItemInput,
} from './domain/stockTransferTypes';
